import * as React from 'react';
import { BaseDateInput } from './BaseDateInput';
import classNames from 'classnames';
import * as Classes from '../common/classes';

export type DateInputProps = Omit<
  React.ComponentProps<typeof BaseDateInput>,
  'showTime' | 'monthPicker' | 'convertValue'
>;

export const DateInput: React.FC<DateInputProps> = ({
  className,
  dataTest,
  ...other
}) => {
  return (
    <BaseDateInput
      dataTest={dataTest}
      className={classNames(
        className,
        Classes.DATE_INPUT,
        Classes.STRING_DATE_INPUT
      )}
      {...other}
      showTime={false}
    />
  );
};
